import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-grid-artists',
  templateUrl: './section-grid-artists.component.html',
  styleUrls: ['./section-grid-artists.component.css']
})
export class SectionGridArtistsComponent implements OnInit {

  @Input() sectionInfo;
  
  constructor() { }

  ngOnInit(): void {
  }

}
